import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { PTicketService } from '../../../services/p-ticket.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { pTicket } from '../../../interfaces/pTicket';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import {
  MatSort,
  MatSortable,
  MatSortModule,
  Sort,
} from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { PTicketFilterComponent } from '../p-ticket-filter/p-ticket-filter.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { report } from '../../../interfaces/preport';
import { MatDialog } from '@angular/material/dialog';
import { NewReportDialogComponent } from '../../reporting/new-report-dialog/new-report-dialog.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PTicketNewComponent } from '../p-ticket-new/p-ticket-new.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderTitleService } from '../../../services/header-title.service';
import { SocketService } from '../../../services/socket.service';
import { OrganizationService } from '../../../services/organization.service';
import { globalUser } from '../../../helpers/globalFields';
import { MasterDataService } from '../../../services/master-data.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { Filters } from '../../../mock-data/mock-filters';
import { UserService } from '../../../services/user.service';
import { debounceTime, distinctUntilChanged, forkJoin, Subject } from 'rxjs';
import { ActiveFilter } from '../../../interfaces/active-filter';
import { HighlightPipe } from '../../../pipes/highlight.pipe';

export interface Chip {
  selected: Boolean;
  value: string;
  display: string;
}

@Component({
  selector: 'app-p-ticket-list',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    FormsModule,
    CommonModule,
    MatTableModule,
    RouterModule,
    MatSortModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatChipsModule,
    MatCheckboxModule,
    MatCardModule,
    DragDropModule,
    PTicketFilterComponent,
    MatButtonModule,
    NgxSkeletonLoaderModule,
    MatIconModule,
    MatTabsModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatTooltipModule,
    OverlayModule,
    HighlightPipe
  ],
  templateUrl: './p-ticket-list.component.html',
  styleUrl: './p-ticket-list.component.scss',
})
export class PTicketListComponent {
  constructor(
    private pTicketService: PTicketService,
    private headerTitleService: HeaderTitleService,
    private socketService: SocketService,
    private organizationService: OrganizationService,
    private masterDataService: MasterDataService,
    private userService: UserService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private route: ActivatedRoute,

    @Inject(LOCALE_ID) private locale: string,
  ) { }

  private tccSearchSubject = new Subject<string>();
  private pccSearchSubject = new Subject<string>();


  pTicketsList: pTicket[] = [];

  @ViewChild('pccSort') pccSort!: MatSort;
  @ViewChild('tccSort') tccSort!: MatSort;
  @ViewChild('pccPaginator', { read: MatPaginator })
  pccPaginator!: MatPaginator;
  @ViewChild('tccPaginator', { read: MatPaginator })
  tccPaginator!: MatPaginator;

  @ViewChild('tccTicketFilter') tccTicketFilter!: PTicketFilterComponent;
  @ViewChild('pccTicketFilter') pccTicketFilter!: PTicketFilterComponent;

  pccDataSource = new MatTableDataSource<pTicket & { pkeywordsflat: string }>(
    [],
  );
  tccDataSource = new MatTableDataSource<pTicket & { pkeywordsflat: string }>(
    [],
  );

  pccSearchbarEntry = '';
  tccSearchbarEntry = '';

  private readonly LS_PCC_COLS = 'pccDisplayedColumns';
  private readonly LS_TCC_COLS = 'tccDisplayedColumns';

  pccDisplayedColumns: string[] = [
    'id',
    'pct_user',
    'pct_initialdescription',
    'actions',
  ];
  tccDisplayedColumns: string[] = [
    'id',
    'pct_user',
    'pct_initialdescription',
    'actions',
  ];

  currentUser = globalUser;

  emptyPTicket: pTicket = {
    id: 1,
    pct_status: '',
    pct_tickettype: '',
    pct_supportlevel: '',
    pct_useremail: '',
    pct_user: '',
    pct_company: '',
    pct_product: '',
    pct_initialdescription: '',
    pct_callbacknumber: '',
    pct_responsename: '',
    pct_responseemail: '',
    pct_countrycode: '',
    pct_issuetype: '',
    pct_severity: '',
    pct_component: '',
    pct_status_granulated: '',
    pct_system_version: '',
    pct_has_solution: 'false',
    pct_author: '',
    pct_creator: '',
  };

  report!: report;
  loadingPTicketDataSource = new MatTableDataSource([
    this.emptyPTicket,
    this.emptyPTicket,
    this.emptyPTicket,
    this.emptyPTicket,
    this.emptyPTicket,
  ]);

  allColumns: string[] = [
    'pct_organization',
    'id',
    'pct_useremail',
    'pct_user',
    'pct_company',
    'pct_product',
    'pct_initialdescription',
    'pct_callbacknumber',
    'pct_responsename',
    'pct_responseemail',
    'pct_status_granulated',
    'pkeywordsflat',
    'pct_countrycode',
    'actions',
  ];
  allDisplays: string[] = [
    'Organization',
    'Ticket Id',
    'User mail',
    'Username',
    'Company',
    'Product',
    'Description',
    'Callback phone',
    'Contact',
    'Contact mail',
    'Status',
    'Keywords',
    'Country',
    'Actions',
  ];

  tccPage = 1;
  tccLimit = 30;
  tccTotal = 0;

  pccPage = 1;
  pccLimit = 30;
  pccTotal = 0;

  tccChips!: Chip[];
  pccChips!: Chip[];

  isLoading = true;
  protected globalUser = globalUser;
  allOrganizations: any[] = [];
  canCreateTicket = false;
  canMoveTicket = false;

  tccFilterOpen = false;
  pccFilterOpen = false;

  /** Per-tab current params — reused on org-change or refresh */
  tccCurrentHttpParams: HttpParams = new HttpParams();
  pccCurrentHttpParams: HttpParams = new HttpParams();

  tccSortActive = 'id';
  tccSortDirection: 'asc' | 'desc' = 'desc';

  pccSortActive = 'id';
  pccSortDirection: 'asc' | 'desc' = 'desc';

  tccActiveFilterChips: {
    id: string;
    display: string;
    db_key: string;
    value: string;
  }[] = [];
  pccActiveFilterChips: {
    id: string;
    display: string;
    db_key: string;
    value: string;
  }[] = [];

  /** Per-tab saved filters from DB — passed as @Input to filter components */
  tccFilters: ActiveFilter[] = [];
  pccFilters: ActiveFilter[] = [];

  ngAfterViewInit(): void {
    const startDate = new Date('2023-01-01T00:00:00.000Z');
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);

    this.pTicketService
      .getAll(
        new HttpParams()
          .append('pct_tickettype', 'pCC')
          .append('pct_status', 'open')
          .append('updatedAt[$gte]', startDate.toISOString())
          .append('updatedAt[$lte]', endDate.toISOString()),
      )
      .subscribe(({ pagination }) => {
        this.headerTitleService.setTitle(
          pagination.total === 0 ? 'Tickets' : `Tickets (${pagination.total})`,
        );
      });

    this.userService.getTableFilters().subscribe((allFilters) => {
      this.tccFilters = this.hydrateFilterReferences(allFilters['tCC'] || []);
      this.pccFilters = this.hydrateFilterReferences(allFilters['pCC'] || []);

      this.tccCurrentHttpParams = this.buildHttpParamsFromActive(
        this.tccFilters,
      );

      this.pccCurrentHttpParams = this.buildHttpParamsFromActive(
        this.pccFilters,
      );

      this.initTccData(this.tccCurrentHttpParams);
      this.initPccData(this.pccCurrentHttpParams);
    });
  }

  ngOnInit(): void {
    this.organizationService.currentOrg$.subscribe((org) => {
      if (org && this.router.url.startsWith('/pTickets/list')) {
        this.initTccData(this.tccCurrentHttpParams);
        this.initPccData(this.pccCurrentHttpParams);
      }
    });

    this.masterDataService
      .getMasterOrganizationList()
      .subscribe((r) => (this.allOrganizations = r));

    globalUser.getUserStream().subscribe((user) => {
      if (user) {
        this.canCreateTicket = globalUser.validatePermission('ticket.create');
        this.canMoveTicket = globalUser.validatePermission('ticket.move');
      }
    });

    this.socketService
      .onValueChanged()
      .subscribe((v) =>
        this.headerTitleService.setTitle(
          v === 0 ? 'Tickets' : `Tickets (${v})`,
        ),
      );
    this.socketService
      .onTicketOpened()
      .subscribe((v) =>
        this.headerTitleService.setTitle(
          v === 0 ? 'Tickets' : `Tickets (${v})`,
        ),
      );

    this.tccChips = [];
    this.pccChips = [];
    this.pccDisplayedColumns = [
      'id',
      'pct_user',
      'pct_initialdescription',
      'actions',
    ];
    this.tccDisplayedColumns = [
      'id',
      'pct_user',
      'pct_initialdescription',
      'actions',
    ];

    const savedPccCols = localStorage.getItem(this.LS_PCC_COLS);
    const savedTccCols = localStorage.getItem(this.LS_TCC_COLS);
    if (savedPccCols) this.pccDisplayedColumns = JSON.parse(savedPccCols);
    if (savedTccCols) this.tccDisplayedColumns = JSON.parse(savedTccCols);

    this.initTableFilters();

    this.tccSearchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((term) => {
        this.tccSearchbarEntry = term;
        this.initTccData(this.tccCurrentHttpParams, 1); // reset to page 1 on new search
      });

    this.pccSearchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((term) => {
        this.pccSearchbarEntry = term;
        this.initPccData(this.pccCurrentHttpParams, 1);
      });
  }

  private computeActiveFilterChips(tab: 'tCC' | 'pCC'): void {
    const filters = tab === 'tCC' ? this.tccFilters : this.pccFilters;

    const chips = filters
      .filter((f) => f.key && this.isFilterValid(f))
      .map((f) => {
        // ensure legacy/hydrated filters without an id still get one
        if (!f.id) f.id = crypto.randomUUID();

        if (f.key!.filterType === 'dateRange') {
          const fmt = new Intl.DateTimeFormat(this.locale, {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          });
          return {
            id: f.id,
            display: 'Updated',
            db_key: 'updatedAt',
            value: `${fmt.format(new Date(f.value.start))} – ${fmt.format(new Date(f.value.end))}`,
          };
        }

        return {
          id: f.id,
          display: f.key!.display_key ?? f.key!.db_key,
          db_key: f.key!.db_key,
          value: f.value,
        };
      });

    if (tab === 'tCC') this.tccActiveFilterChips = chips;
    else this.pccActiveFilterChips = chips;
  }

  private isFilterValid(f: ActiveFilter): boolean {
    if (f.key?.filterType === 'dateRange') {
      return !!f.value?.start && !!f.value?.end;
    }
    return f.value !== null && f.value !== undefined && f.value !== '';
  }

  private buildHttpParamsFromActive(filters: ActiveFilter[]): HttpParams {
    let params = new HttpParams();

    filters.forEach((filter) => {
      if (!filter.key || filter.value == null || filter.value === '') {
        return;
      }

      if (filter.key.filterType === 'dateRange') {
        const start = filter.value?.start;
        const end = filter.value?.end;

        if (start && end) {
          params = params
            .append('updatedAt[$gte]', new Date(start).toISOString())
            .append('updatedAt[$lte]', new Date(end).toISOString());
        }

        return;
      }

      params = params.append(filter.key.db_key, filter.value);
    });

    return params;
  }



  onTccSearchInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.tccSearchSubject.next(value);
  }

  onPccSearchInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.pccSearchSubject.next(value);
  }


  private mapTickets(tickets: pTicket[]) {
    return tickets.map((t) => ({
      ...t,
      pkeywordsflat: t.pkeywords?.map((k) => k.pkw_value).join(', ') || '',
    }));
  }

  initTccData(httpParams: HttpParams, page: number = 1): void {
    this.tccCurrentHttpParams = httpParams;
    this.tccPage = page;
    this.computeActiveFilterChips('tCC');
    this.isLoading = true;

    let params = httpParams
      .set('pct_tickettype', 'tCC')
      .set('page', page)
      .set('limit', this.tccLimit)
      .set('sortBy', this.tccSortActive)
      .set('sortOrder', this.tccSortDirection);

    if (this.tccSearchbarEntry.trim()) {
      params = params.set('search', this.tccSearchbarEntry.trim());
    }

    this.pTicketService.getAll(params).subscribe(({ data, pagination }) => {
      const mapped = this.mapTickets(data);
      this.tccTotal = pagination.total;

      this.tccDataSource = new MatTableDataSource(mapped);
      // no .sort assignment — server already sorted
      this.tccDataSource.filter = this.tccSearchbarEntry.trim().toLowerCase();
      this.isLoading = false;
    });
  }

  initPccData(httpParams: HttpParams, page: number = 1): void {
    this.pccCurrentHttpParams = httpParams;
    this.pccPage = page;
    this.computeActiveFilterChips('pCC');

    let params = httpParams
      .set('pct_tickettype', 'pCC')
      .set('page', page)
      .set('limit', this.pccLimit)
      .set('sortBy', this.pccSortActive)
      .set('sortOrder', this.pccSortDirection);


    if (this.pccSearchbarEntry.trim()) {
      params = params.set('search', this.pccSearchbarEntry.trim());
    }
    this.pTicketService.getAll(params).subscribe(({ data, pagination }) => {
      const mapped = this.mapTickets(data);
      this.pccTotal = pagination.total;

      this.pccDataSource = new MatTableDataSource(mapped);
      this.pccDataSource.filter = this.pccSearchbarEntry.trim().toLowerCase();
    });
  }

  onTccPageChange(event: PageEvent): void {
    this.tccLimit = event.pageSize;
    this.initTccData(this.tccCurrentHttpParams, event.pageIndex + 1);
  }

  onPccPageChange(event: PageEvent): void {
    this.pccLimit = event.pageSize;
    this.initPccData(this.pccCurrentHttpParams, event.pageIndex + 1);
  }

  onTccSortChange(sort: Sort): void {
    this.tccSortActive = sort.direction ? sort.active : 'id';
    this.tccSortDirection = sort.direction === 'asc' ? 'asc' : 'desc';
    this.initTccData(this.tccCurrentHttpParams, 1); // reset to page 1 on re-sort
  }

  onPccSortChange(sort: Sort): void {
    this.pccSortActive = sort.direction ? sort.active : 'id';
    this.pccSortDirection = sort.direction === 'asc' ? 'asc' : 'desc';
    this.initPccData(this.pccCurrentHttpParams, 1);
  }

  removeActiveFilterChip(
    chip: { id: string; db_key: string; value: string },
    tab: 'tCC' | 'pCC',
  ): void {
    const currentFilters = tab === 'tCC' ? this.tccFilters : this.pccFilters;

    const updated = currentFilters.filter((f) => f.id !== chip.id);

    if (tab === 'tCC') {
      this.tccFilters = updated;
      this.tccCurrentHttpParams = this.buildHttpParamsFromActive(updated);
      this.initTccData(this.tccCurrentHttpParams);
    } else {
      this.pccFilters = updated;
      this.pccCurrentHttpParams = this.buildHttpParamsFromActive(updated);
      this.initPccData(this.pccCurrentHttpParams);
    }

    this.userService.saveTableFilters(tab, updated).subscribe({
      error: (err) => console.error('Failed to save filters', err),
    });
  }

  /**private computeActiveFilterChips(
    httpParams: HttpParams,
    tab: 'tCC' | 'pCC',
  ): void {
    const dateChip = this.buildDateRangeChip(httpParams);
    const fieldChips = httpParams
      .keys()
      .filter(
        (k) =>
          k !== 'updatedAt[$gte]' &&
          k !== 'updatedAt[$lte]' &&
          k !== 'pct_tickettype',
      )
      .flatMap((key) => {
        const option = Filters.find((f) => f.db_key === key);
        const display = option?.display_key ?? key;
        return httpParams
          .getAll(key)!
          .map((value) => ({ display, db_key: key, value }));
      });

    const chips = dateChip ? [dateChip, ...fieldChips] : fieldChips;
    if (tab === 'tCC') this.tccActiveFilterChips = chips;
    else this.pccActiveFilterChips = chips;
  }**/

  private hydrateFilterReferences(filters: ActiveFilter[]): ActiveFilter[] {
    return filters.map((f) => ({
      ...f,
      id: f.id ?? crypto.randomUUID(),
      key: this.findFilterOption(f.key?.db_key),
    }));
  }

  private findFilterOption(dbKey?: string) {
    if (!dbKey) return null;
    return Filters.find((f) => f.db_key === dbKey) ?? null;
  }

  private buildDateRangeChip(
    httpParams: HttpParams,
  ): { display: string; db_key: string; value: string } | null {
    const start = httpParams.get('updatedAt[$gte]');
    const end = httpParams.get('updatedAt[$lte]');
    if (!start || !end) return null;
    const fmt = new Intl.DateTimeFormat(this.locale, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
    return {
      display: 'Updated',
      db_key: 'updatedAt',
      value: `${fmt.format(new Date(start))} – ${fmt.format(new Date(end))}`,
    };
  }

  /**removeActiveFilterChip(
    chip: { db_key: string; value: string },
    tab: 'tCC' | 'pCC',
  ): void {
    const currentFilters = tab === 'tCC' ? this.tccFilters : this.pccFilters;

    let updated: ActiveFilter[];

    if (chip.db_key === 'updatedAt') {
      updated = currentFilters.filter((f) => f.key?.db_key !== 'updatedAt');
    } else {
      updated = currentFilters.filter(
        (f) => !(f.key?.db_key === chip.db_key && f.value === chip.value),
      );
    }

    // update local state FIRST (single source of truth)
    if (tab === 'tCC') {
      this.tccFilters = updated;
      this.tccCurrentHttpParams = this.buildHttpParamsFromActive(updated);
      this.initTccData(this.tccCurrentHttpParams);
    } else {
      this.pccFilters = updated;
      this.pccCurrentHttpParams = this.buildHttpParamsFromActive(updated);
      this.initPccData(this.pccCurrentHttpParams);
    }

    // persist to backend
    this.userService.saveTableFilters(tab, updated).subscribe({
      error: (err) => console.error('Failed to save filters', err),
    });
  }**/

  initTableFilters() {
    for (let i = 0; i < this.allColumns.length; i++) {
      this.pccChips.push({
        selected: this.pccDisplayedColumns.includes(this.allColumns[i]),
        value: this.allColumns[i],
        display: this.allDisplays[i],
      });
      this.tccChips.push({
        selected: this.tccDisplayedColumns.includes(this.allColumns[i]),
        value: this.allColumns[i],
        display: this.allDisplays[i],
      });
    }
  }

  getDisplayName(col: string): string {
    return this.allDisplays[this.allColumns.indexOf(col)] || col;
  }

  onAddReport(tab: 'tCC' | 'pCC'): void {
    const report: report = {
      id: -1,
      rep_title: 'New Report',
      rep_filter:
        tab === 'tCC' ? this.tccCurrentHttpParams : this.pccCurrentHttpParams,
      rep_xAxisOption: { key: 'pct_has_solution', label: 'Has Solution' },
      rep_chartType: "doughnut"
    };

    const dialogRef = this.dialog.open(NewReportDialogComponent, {
      data: { report },
      maxWidth: '800px',
      panelClass: 'custom-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.router.navigate(['/reporting/overview']);
      }
    });
  }

  onNewTicket(listtype: string): void {
    this.dialog.open(PTicketNewComponent, {
      data: { pct_tickettype: listtype },
      maxWidth: '800px',
      panelClass: 'custom-dialog-container',
    });
  }

  onMoveToOrg(data: pTicket, org: string) {
    this.pTicketService
      .move(data.id, { pct_organization: org })
      .subscribe(() => {
        this.initTccData(this.tccCurrentHttpParams);
        this.initPccData(this.pccCurrentHttpParams);
      });
  }


  onEdit(id: number): void {
    window.open(
      this.router.serializeUrl(this.router.createUrlTree([`/pTicket/${id}`])),
      '_blank',
    );
  }

  onDuplicateTicket(ticket: pTicket): void {
    this.pTicketService
      .create({
        pct_supportlevel: '1',
        pct_status: ticket.pct_status,
        pct_tickettype: ticket.pct_tickettype,
        pct_user: ticket.pct_user,
        pct_responsename: ticket.pct_responsename,
        pct_company: ticket.pct_company,
        pct_countrycode: ticket.pct_countrycode,
        pct_callbacknumber: ticket.pct_callbacknumber,
        pct_responseemail: ticket.pct_responseemail,
        pct_useremail: ticket.pct_useremail,
        pct_initialdescription:
          'This ticket was duplicated from ticket ' + ticket.id,
      })
      .subscribe((data) => this.onEdit(data.id));
  }

  toggleSelection(table: string, chip: Chip) {
    chip.selected = !chip.selected;
    if (table === 'pcc') {
      this.pccDisplayedColumns = this.pccChips
        .filter((c) => c.selected)
        .map((c) => c.value);
      localStorage.setItem(
        this.LS_PCC_COLS,
        JSON.stringify(this.pccDisplayedColumns),
      );
    }
    if (table === 'tcc') {
      this.tccDisplayedColumns = this.tccChips
        .filter((c) => c.selected)
        .map((c) => c.value);
      localStorage.setItem(
        this.LS_TCC_COLS,
        JSON.stringify(this.tccDisplayedColumns),
      );
    }
  }

  onMoveTotCC(ticket: pTicket) {
    this.pTicketService
      .update(ticket.id, { pct_tickettype: 'tCC' })
      .subscribe(() => {
        this.initTccData(this.tccCurrentHttpParams);
        this.initPccData(this.pccCurrentHttpParams);
      });
  }

  private readonly EXPORT_COLUMNS: { key: keyof pTicket; label: string }[] = [
    { key: 'id', label: 'Ticket Id' },
    { key: 'pct_organization', label: 'Organization' },
    { key: 'pct_status', label: 'Status' },
    { key: 'pct_status_granulated', label: 'Granulated Status' },
    { key: 'pct_tickettype', label: 'Ticket Type' },
    { key: 'pct_supportlevel', label: 'Support Level' },
    { key: 'pct_useremail', label: 'User mail' },
    { key: 'pct_user', label: 'Username' },
    { key: 'pct_company', label: 'Company' },
    { key: 'pct_product', label: 'Product' },
    { key: 'pct_initialdescription', label: 'Description' },
    { key: 'pct_callbacknumber', label: 'Callback phone' },
    { key: 'pct_responsename', label: 'Contact' },
    { key: 'pct_responseemail', label: 'Contact mail' },
    { key: 'pct_countrycode', label: 'Country' },
    { key: 'pct_issuetype', label: 'Issue Type' },
    { key: 'pct_severity', label: 'Severity' },
    { key: 'pct_component', label: 'Component' },
    { key: 'pct_system_version', label: 'System Version' },
    { key: 'pct_has_solution', label: 'Has Solution' },
    { key: 'pct_author', label: 'Author' },
    { key: 'pct_creator', label: 'Creator' },
  ];

  tccExportLoading = false;
  pccExportLoading = false;

  onDownloadAll(tab: 'tCC' | 'pCC'): void {
    const httpParams =
      tab === 'tCC' ? this.tccCurrentHttpParams : this.pccCurrentHttpParams;

    const params = httpParams
      .set('pct_tickettype', tab)
      .set('sortBy', tab === 'tCC' ? this.tccSortActive : this.pccSortActive)
      .set(
        'sortOrder',
        tab === 'tCC' ? this.tccSortDirection : this.pccSortDirection,
      );

    if (tab === 'tCC') this.tccExportLoading = true;
    else this.pccExportLoading = true;

    this.pTicketService.getAllForExport(params).subscribe({
      next: (tickets) => {
        this.downloadCsv(tickets, `${tab}_ticket_export`);
      },
      error: (err) => {
        console.error('Export failed:', err);
      },
      complete: () => {
        if (tab === 'tCC') this.tccExportLoading = false;
        else this.pccExportLoading = false;
      },
    });
  }

  private downloadCsv(tickets: any[], fileName: string): void {
    const baseUrl = window.location.origin;

    const headerRow = [...this.EXPORT_COLUMNS.map((c) => c.label), 'Link'];

    const rows = tickets.map((t) => {
      const cells = this.EXPORT_COLUMNS.map((col) => this.csvEscape(t[col.key]));

      const link = `${baseUrl}/pTicket/${t.id}`;
      cells.push(this.csvEscape(link));

      return cells.join(',');
    });

    const csvContent = [headerRow.join(','), ...rows].join('\r\n');

    // UTF-8 BOM so Excel opens special characters (ä, ö, ü, etc.) correctly
    const blob = new Blob(['\uFEFF' + csvContent], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  private csvEscape(value: any): string {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (/[",\n]/.test(str)) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  }
  private readonly NON_SEARCHABLE_COLUMNS = new Set(['actions']);

  isSearchableColumn(col: string): boolean {
    return !this.NON_SEARCHABLE_COLUMNS.has(col);
  }
}
